import { render, staticRenderFns } from "./testimonialsCard.vue?vue&type=template&id=80eab804&scoped=true&"
import script from "./testimonialsCard.vue?vue&type=script&lang=js&"
export * from "./testimonialsCard.vue?vue&type=script&lang=js&"
import style0 from "./testimonialsCard.vue?vue&type=style&index=0&id=80eab804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80eab804",
  null
  
)

export default component.exports